const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID;

type GoogleAnalyticsCommand = ['js', Date] | ['config', string];

type GoogleAnalyticsWindow = Window & {
  dataLayer?: IArguments[];
  gtag?: (...args: GoogleAnalyticsCommand) => void;
};

export function initGoogleAnalytics() {
  if (import.meta.env.VITE_ENABLE_ANALYTICS !== 'true' || !GA_MEASUREMENT_ID) {
    return;
  }

  const analyticsWindow = window as GoogleAnalyticsWindow;

  if (analyticsWindow.gtag) {
    return;
  }

  const dataLayer = (analyticsWindow.dataLayer ??= []);

  const gtag: NonNullable<GoogleAnalyticsWindow['gtag']> = function () {
    // eslint-disable-next-line prefer-rest-params
    dataLayer.push(arguments);
  };

  analyticsWindow.gtag = gtag;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;

  document.head.appendChild(script);

  gtag('js', new Date());
  gtag('config', GA_MEASUREMENT_ID);
}
